import { COLOR } from "../../../constants/global.constants";

export const customStyles = (
  defaultStyle = true,
  isError = false,
  isBorderRadius = false
) => ({
  container: (provided) => ({
    ...provided,
    width: "100%",
  }),
  control: (provided) => ({
    ...provided,
    boxShadow: "none",
    borderRadius: isBorderRadius ? "25px" : "8px",
    border: `1px solid ${
      !isError ? (defaultStyle ? COLOR.WHITE : COLOR.TEAL) : "#f00"
    }`,
    backgroundColor: COLOR.TRANSPARENT,
    "&:hover": {
      border: `1px solid ${
        !isError ? (defaultStyle ? COLOR.WHITE : COLOR.TEAL) : "#f00"
      }`,
    },
    "&:focus": {
      border: `1px solid ${
        !isError ? (defaultStyle ? COLOR.WHITE : COLOR.TEAL) : "#f00"
      }`,
    },
  }),
  option: (provided, state) => ({
    ...provided,
    color: COLOR.BLACK,
    backgroundColor: state.isSelected ? COLOR.TEAL : COLOR.WHITE,
    padding: 10,
    "&:hover": {
      backgroundColor: COLOR.TEAL_HOVER,
    },
  }),
  input: (provided) => ({
    ...provided,
    color: !defaultStyle ? "#575756" : COLOR.WHITE,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: !defaultStyle ? "#7a7a7a" : COLOR.WHITE,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: !defaultStyle ? "#575756" : COLOR.WHITE,
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "200px",

    "::-webkit-scrollbar": {
      width: "5px",
    },
    "::-webkit-scrollbar-track": {
      background: COLOR.WHITE,
      borderRadius: "25px",
    },
    "::-webkit-scrollbar-thumb": {
      background: COLOR.TEAL,
      borderRadius: "25px",
    },
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 10000,
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: !defaultStyle ? "#f2f2f2" : COLOR.TEAL,
    borderRadius: "5px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: !defaultStyle ? "#575756" : COLOR.WHITE,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    fontSize: !defaultStyle ? "24px" : "auto",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: COLOR.WHITE,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "unset",
      color: COLOR.WHITE,
    },
    ...(!defaultStyle
      ? {
          height: "10px",
          width: "1rem",
          color: "#000",
          "&:hover": {
            color: "#000",
            background: "unset",
          },
        }
      : {}),
  }),
});
